import { profileRouteValidator } from '@frontend/member-route-validators';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/app/profile')({
  validateSearch: profileRouteValidator,
});
